import { BaseElements, BaseObject, BaseService, BaseInjector } from '../../js/base';

class Texts extends BaseObject { }

class ClassList extends BaseObject {
    seeMore = 'cited-by__see-more';
    hide = 'd-none';
    listItemClasses = 'pb-3 mb-4 border-bottom';
}

class Selectors extends BaseObject {
    list = '.cited-by__list';
    spinner = '.cited-by__spinner';
}

class Elements extends BaseElements<Selectors> {
    list: HTMLElement;
    spinner: HTMLElement;
    wrapper: HTMLElement;

    constructor(selectors: Selectors) {
        super(selectors, false);
    }

    setWrapper(wrapper: HTMLElement) {
        this.wrapper = wrapper;
        this.initElements();
    }
    initElements() {
        this.initElementsByLoop();
    }
}

interface CitedBy extends BaseService<Selectors, Elements, ClassList, Texts> { }

@BaseInjector(Selectors, Elements, ClassList, Texts)
class CitedBy {
    isLazyLoading = false;

    constructor(readonly wrapper: HTMLElement) { }

    initialize(): void {
        this.elements.setWrapper(this.wrapper);
        this.isLazyLoading = this.elements.list.dataset.lazyload === 'true';
        if (this.isLazyLoading) {
            this.sendAjax(this.elements.list.dataset.source)
        }
        this.addEventListeners();
    }

    addEventListeners() {
        this.elements.list.addEventListener('click', this.onClick.bind(this));
    }

    onClick(e: Event) {
        e.stopPropagation();
        const target = e.target as HTMLElement;
        if (!target.classList.contains(this.classList.seeMore)) {
            return;
        }
        let parentLi = target.parentElement,
            ajaxUrl = target.dataset.source;
        parentLi.remove();
        this.sendAjax(ajaxUrl);
    }



    async sendAjax(url) {
        // url = 'ajax/content.json'
        try {

            this.setIsLoading(true);
            const response = await fetch(url);
            const data = await response.json();
            if (!data.item.citations.length) {
                return;
            }
            const html = data.item.citations.map(item => {
                return this.listItem(item, data);
            }).join('');

            this.elements.list.insertAdjacentHTML('beforeend', html);

            if (data.seeMoreLink) {
                this.elements.list.insertAdjacentHTML('beforeend', this.seeMore(data.seeMoreLink));
            }
            this.setIsLoading(false);
        } catch (e) {
            this.setIsLoading(false);
        }
    }

    setIsLoading(done) {
        this.elements.spinner.classList.toggle(this.classList.hide, !done);
    }

    seeMore(link) {
        return `
            <li class="cited-by__entry--see-more">
                <a href="javascript:void(0)" data-source="${link}" class="cited-by__see-more">See more</a>
            </li>
        `;
    }

    authorsList(authors) {
        if (authors && authors.length) {
            const authorsHTML = authors.map(({ firstName, surname }) => `
                <li class="list-inline-item cited-by__entry__author">
                    ${firstName} ${surname},
                 </li>`).join('');

            return `
            <ul class="cited-by__entry__authors list-inline">
                ${authorsHTML}
            </ul>`;
        }
        return '';
    }

    listItem(citation, data) {
        let link = (citation.source === 'crossref') ? data.registry.crossrefUrl + citation.doi : '/doi/' + citation.doi,
            label = (citation.source === 'crossref') ? data.crossrefLinkLabel : data.internalLinkLabel;
        return `
        <li class="cited-by__entry ${this.classList.listItemClasses}">
            ${this.authorsList(citation.contributors)}
            <span class="cited-by__entry__title">${citation.itemTitle}, </span>
            ${citation.parentTitle ? `<span class="cited-by__entry__series-title">${citation.parentTitle}, </span>` : ''}
            ${citation.volume ? `<span class="cited-by__entry__volume"><b>${citation.volume}</b>, </span>` : ''}
            ${citation.issue ? `<span class="cited-by__entry__issue">${citation.issue}, </span>` : ''}
            ${citation.firstPage ? `<span class="cited-by__entry__page-range">(${citation.firstPage}${citation.lastPage ? `-${citation.lastPage}` : ''}), </span>` : ''}
            ${citation.year ? `<span class="cited-by__entry__pub-date">(${citation.year}). </span>` : ''}
            <a href="${link}" title="${label}" class="cited-by__entry__doi">${link}</a>
            <div class="cited-by__entry__extra-links">
                <a href="${link}" class="cited-by__entry__visitable">${label}</a>
            </div>
        </li>
        
        `;
    }

}

export default CitedBy;

export {
    Elements as CitedByElements,
    Selectors as CitedBySelectors,
    ClassList as CitedByClassList,
    Texts as CitedByTexts
}